import BusinessCalendarLine from './business-calendar-line.component.js'

export * from './business-calendar-line.component.js'
export default BusinessCalendarLine

BusinessCalendarLine.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-calendar-line': BusinessCalendarLine
  }
}
